/** Shared hex parsing for `ColorInput` and `reactHexagonPicker` comparison helpers. */

/** Returns normalized `#rrggbb` when the string is a complete hex color, else null. */
export function tryCompleteHex(value: string): string | null {
  const t = value.trim();
  const u = t.startsWith('#') ? t : `#${t}`;
  const six = u.match(/^#([0-9a-fA-F]{6})$/);
  if (six) {
    return `#${six[1].toLowerCase()}`;
  }
  const three = u.match(/^#([0-9a-fA-F]{3})$/);
  if (three) {
    const [a, b, c] = three[1];
    return `#${a}${a}${b}${b}${c}${c}`.toLowerCase();
  }
  return null;
}

export function parseHexToRgb(hex: string): [number, number, number] | null {
  const t = hex.trim();
  const six = t.match(/^#([0-9a-fA-F]{6})$/);
  if (six) {
    const n = Number.parseInt(six[1], 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  const three = t.match(/^#([0-9a-fA-F]{3})$/);
  if (three) {
    const [a, b, c] = three[1];
    return [Number.parseInt(a + a, 16), Number.parseInt(b + b, 16), Number.parseInt(c + c, 16)];
  }
  return null;
}

export function rgbToHsv(r: number, g: number, b: number): { h: number; s: number; v: number } {
  const rn = r / 255;
  const gn = g / 255;
  const bn = b / 255;
  const max = Math.max(rn, gn, bn);
  const min = Math.min(rn, gn, bn);
  const d = max - min;
  let h = 0;
  if (d > 1e-10) {
    if (max === rn) h = 60 * (((gn - bn) / d + 6) % 6);
    else if (max === gn) h = 60 * ((bn - rn) / d + 2);
    else h = 60 * ((rn - gn) / d + 4);
  }
  const s = max < 1e-10 ? 0 : d / max;
  return { h, s, v: max };
}
